import { SetScheduleData } from '@api/Trinium/Endpoints/Leg/types';
import { apiIsoStringFormat, parseDayJsRange } from '@/Infrastructure/Utilities/dayjs.type';
import { UpdateScheduledPuDlFormik } from './types';

/**
 * Method used for mapping a Leg type to a DispatchLeg type for optimistic updates when mutating the cache.
 */
export function updateScheduledPuDlToApiRaw(formValues: Partial<UpdateScheduledPuDlFormik>) {
	const scheduledPickupDates = parseDayJsRange(formValues.scheduledPickupDateRange);
	const scheduledDeliveryDates = parseDayJsRange(formValues.scheduledDeliveryDateRange);

	const updates: Omit<SetScheduleData, 'legIds'> = {
		schdPuFrom: formValues.scheduledPickupDateRange ? (scheduledPickupDates[0]?.format(apiIsoStringFormat) ?? null) : undefined,
		schdPuTo: formValues.scheduledPickupDateRange ? (scheduledPickupDates[1]?.format(apiIsoStringFormat) ?? null) : undefined,
		schdDelvFrom: formValues.scheduledDeliveryDateRange ? (scheduledDeliveryDates[0]?.format(apiIsoStringFormat) ?? null) : undefined,
		schdDelvTo: formValues.scheduledDeliveryDateRange ? (scheduledDeliveryDates[1]?.format(apiIsoStringFormat) ?? null) : undefined,

		// Remove Scheduled Pickup/Delivery
		removeSchdPuTimes: formValues.removeScheduledPickup,
		removeSchdPuDate: formValues.removeScheduledPickup,
		removeSchdDelvTimes: formValues.removeScheduledDelivery,
		removeSchdDelvDate: formValues.removeScheduledDelivery
	};

	Object.keys(updates).forEach((key) => {
		const asKey = key as keyof typeof updates;
		// If the value is undefined than remove it from the request
		if (updates[asKey] === undefined) {
			// eslint-disable-next-line @typescript-eslint/no-dynamic-delete
			delete updates[asKey];
		}
	});

	return updates;
}
